import { useContext } from 'react';
import { useMutation } from 'react-query';
import { AuthContext } from '../../Context/AuthContext';

const useDeletePendingProfile = () => {
  const { token } = useContext(AuthContext); 

  return useMutation(async (data) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/delete/pendingDeletes`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, 
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return response.json();
  });
};

export default useDeletePendingProfile;
